import type { AppThunk } from 'typesafe-actions';
import { createAsyncAction } from 'typesafe-actions';

import { fetchExperiments } from './apis';
import type { ExperimentsConfig } from './types';

export const fetchExperimentsAsync = createAsyncAction(
  'FETCH_EXPERIMENTS_REQUEST',
  'FETCH_EXPERIMENTS_SUCCESS',
  'FETCH_EXPERIMENTS_FAILURE',
)<undefined, ExperimentsConfig, string>();

export const fetchExperimentsConfig =
  (fileName: string): AppThunk =>
  async (dispatch, getState, { apiClient }) => {
    try {
      dispatch(fetchExperimentsAsync.request());
      const response = await fetchExperiments(apiClient, fileName);
      dispatch(fetchExperimentsAsync.success(response));
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to fetch experiments';
      dispatch(fetchExperimentsAsync.failure(errorMessage));
    }
  };

export const setUserId = (userId: string | null) => ({
  type: 'SET_USER_ID',
  payload: userId,
});
